module.exports = __webpack_public_path__ + "img/mind_template_item_5_4.28e5ae17.png";